import {
    instance as axios,
    setJwtToken,
  } from '../../config/axiosInstance'
  
  // ---------------------Notification-listing--------------------------
  export const notificationListingApi = async (data) => {
    const endPoint =
      `/admin/notification` + '?' + new URLSearchParams({ ...data }).toString()
    return await axios.get(endPoint, setJwtToken())
  }

//--------------------------Send Notification---------------------
export const sendNotificationApi = async (reqData) => {
    const endPoint =  `/admin/notification/send`
    return await axios.post(endPoint, reqData, setJwtToken())
  }

    // ---------------------Delete Notification--------------------------
    export const deleteNotificationApi = async (data) => {
      const endPoint =
        `/admin/notification/delete` + '?' + new URLSearchParams({ ...data }).toString()
      return await axios.delete(endPoint, setJwtToken())
    }
  
    // ---------------------Get Notification--------------------------
    export const getNotificationApi = async (data) => {
        const endPoint =
          `/admin/notification/admin-notification` + '?' + new URLSearchParams({ ...data }).toString()
        return await axios.get(endPoint, setJwtToken())
      }

      export const markRead = async ({notificationId}) => {
        const endPoint = `/admin/notification/read-notification` + '?' + new URLSearchParams({notificationId:notificationId}).toString()
        return await axios.get(endPoint, setJwtToken())
      }  

      // ---------------------Scheduled Notification APIs--------------------------
      
      // Get scheduled notifications
      export const getScheduledNotificationsApi = async (data) => {
        const endPoint = `/admin/notification/scheduled` + '?' + new URLSearchParams({ ...data }).toString()
        return await axios.get(endPoint, setJwtToken())
      }

      // Add scheduled notification
      export const addScheduledNotificationApi = async (reqData) => {
        const endPoint = `/admin/notification/schedule`
        return await axios.post(endPoint, reqData, setJwtToken())
      }

      // Cancel scheduled notification
      export const cancelScheduledNotificationApi = async (data) => {
        const endPoint = `/admin/notification/scheduled/cancel` + '?' + new URLSearchParams({ ...data }).toString()
        return await axios.delete(endPoint, setJwtToken())
      }

      // Get notification details
      export const getNotificationDetailsApi = async (data) => {
        const endPoint = `/admin/notification/details` + '?' + new URLSearchParams({ ...data }).toString()
        return await axios.get(endPoint, setJwtToken())
      }

      // Fetch targeted users based on advanced filters
      export const fetchTargetedUsersApi = async (reqData) => {
        const endPoint = `/admin/notification/fetch-targeted-users`
        return await axios.post(endPoint, reqData, setJwtToken())
      }

      // Send targeted notifications to specific users
      export const sendTargetedNotificationApi = async (reqData) => {
        const endPoint = `/admin/notification/send-targeted`
        return await axios.post(endPoint, reqData, setJwtToken())
      }

      // Schedule targeted notifications to specific users
      export const scheduleTargetedNotificationApi = async (reqData) => {
        const endPoint = `/admin/notification/schedule-targeted`
        return await axios.post(endPoint, reqData, setJwtToken())
      }

      export const getVedicMeetAutomationOverviewApi = async () =>
        axios.get('/admin/vedicmeet-automatic-notification/overview', setJwtToken())
